import { render, staticRenderFns } from "./ClientsAutocomplete.vue?vue&type=template&id=45ca1cfc"
import script from "./ClientsAutocomplete.vue?vue&type=script&lang=js"
export * from "./ClientsAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports